import React from 'react';
import { Progress } from '@chakra-ui/react';
export const ProgressIndicator = ({ percent }) => {
  let pInt = percent ? parseInt(percent) : 0;
  if (pInt > 100) pInt = 100;
  return <Progress borderRadius="5px" value={pInt} />;
};
